export class AdminStatistics {
	numberOfUsers: number;
	numberOfVehicles: number;
	numberOfVehiclesWithDriverAssigned: number;
	numberOfVehiclesWithDriverDataCompleted: number;
	numberOfElectrificationPlanCreated: number;
}
